/**
 * Single source of truth for reading the API auth token from storage.
 *
 * The SSO gateway stores the token under `x-api-check`; dev email/password
 * login stores it under `access_token`. Prefer SSO, fall back to dev.
 *
 * `AuthService.getToken()` delegates here — components and services should use
 * that method (via DI), NOT read storage directly.
 *
 * The Apollo links (auth-link, error-link, apollo.config wsLink) call this
 * helper directly because they are created outside Angular's DI at module load
 * and cannot inject AuthService without a circular dependency
 * (AuthService → Apollo → APOLLO_OPTIONS → AuthService).
 */
export function readStoredToken(): string | null {
  const value = localStorage.getItem('x-api-check') ?? localStorage.getItem('access_token');
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as unknown;
    return typeof parsed === 'string' ? parsed : value;
  } catch {
    return value;
  }
}
